import { render, staticRenderFns } from "./SpacingBars.vue?vue&type=template&id=b3487804&"
import script from "./SpacingBars.vue?vue&type=script&lang=ts&"
export * from "./SpacingBars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports